import React, { useEffect, useState } from 'react';
import classes from './call-start.module.scss';
import { ReactComponent as PhoneIcon } from '../../img/phone.svg';
import cn from 'classnames';
import Select from '../select/select';
import { Devices } from '../../types/types';
import { getDevices } from '../../utils/utils';
import VolumeMeter from './volume-meter/volume-meter';
import SpeakerTest from './speaker-test/speaker-test';
import { isMobile } from 'react-device-detect';
import LogCollector from '../../controllers/log-collector';

interface CallStartProps {
  logCollector: LogCollector;
  inputDevice: string;
  onChangeInputDevice: (value: string) => void;
  outputDevice: string;
  onChangeOutputDevice: (value: string) => void;
  onCall: () => void;
}

const CallStart = ({
  logCollector,
  inputDevice,
  onChangeInputDevice,
  outputDevice,
  onChangeOutputDevice,
  onCall,
}: CallStartProps) => {
  const [devices, setDevices] = useState<Devices>({ input: [], output: [] });

  useEffect(() => {
    navigator.mediaDevices.addEventListener('devicechange', updateDevices);
    updateDevices();

    return () => {
      navigator.mediaDevices.removeEventListener('devicechange', updateDevices);
    }
    // eslint-disable-next-line
  }, []);

  const updateDevices = () => {
    getDevices().then(({ input, output }) => {
      setDevices({ input, output });
    }).catch(() => {
      logCollector.sendLogs();
    });
  }

  return (
    <div className={cn(classes.callStart, {
      [classes.callStart_mobile]: isMobile,
      [classes.callStart_desktop]: !isMobile,
    })}>

      <div className={cn(classes.callStart__section, classes.devices)}>
        <Select
          selected={inputDevice}
          error={devices.input.length === 0 ? 'Нет доступа к микрофону' : undefined}
          disabled={devices.input.length === 0}
          options={isMobile ? [] : devices.input.map(input => ({
            value: input.deviceId,
            label: input.label,
          }))}
          label="Выберите микрофон"
          onChange={onChangeInputDevice}
        >
          <VolumeMeter deviceId={inputDevice}/>
        </Select>

        <Select
          selected={outputDevice}
          options={isMobile ? [] : devices.output.map(output => ({
            value: output.deviceId,
            label: output.label,
          }))}
          label="Выберите динамик"
          onChange={onChangeOutputDevice}
        >
          <SpeakerTest sinkId={outputDevice}/>
        </Select>
      </div>

      <div className={cn(classes.callStart__section, classes.bottom)}>
        <span className={classes.bottom__text}>
          Нажимая кнопку «Начать вызов», вы разрешаете доступ к микрофону и динамику
        </span>
        <button
          className={cn(classes.bottom__button, classes.button)}
          onClick={onCall}
          disabled={devices.input.length === 0}
        >
          <PhoneIcon className={classes.button__icon}/>
          <span className={classes.button__text}>Начать вызов</span>
        </button>
      </div>
    </div>
  );
}

export default CallStart;